import React from 'react';

const P: Record<string, string> = {
  home: 'M3 10.5 12 3l9 7.5M5 9.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V9.5',
  dm: 'M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H9l-5 4V6a1 1 0 0 1 1-1Z',
  activity: 'M12 3a6 6 0 0 0-6 6v3l-2 3h16l-2-3V9a6 6 0 0 0-6-6ZM9.5 20a2.5 2.5 0 0 0 5 0',
  files: 'M4 5a1 1 0 0 1 1-1h4l2 2h8a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1Z',
  gear: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1Z',
  compose: 'M4 20h4L18.5 9.5a2 2 0 0 0-3-3L5 17v3ZM14.5 6.5l3 3',
  search: 'M11 4a7 7 0 1 0 4.9 12l4.1 4.1M11 4a7 7 0 0 1 4.9 12',
  plus: 'M12 5v14M5 12h14',
  hash: 'M9 4 7 20M17 4l-2 16M5 9h14M4 15h14',
  lock: 'M7 10V8a5 5 0 0 1 10 0v2M6 10h12v9a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1Z',
  chevronDown: 'M6 9l6 6 6-6',
  chevronRight: 'M9 6l6 6-6 6',
  logout: 'M15 4h3a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3M10 8l-4 4 4 4M6 12h10',
  moon: 'M20 14a8 8 0 1 1-9.5-9.8A6.5 6.5 0 0 0 20 14Z',
  bell: 'M12 3a6 6 0 0 0-6 6v3l-2 3h16l-2-3V9a6 6 0 0 0-6-6ZM9.5 20a2.5 2.5 0 0 0 5 0',
  smiley: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM8.5 10h.01M15.5 10h.01M8.5 14.5a5 5 0 0 0 7 0',
  clock: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM12 7v5l3 2',
  calendar: 'M8 2v3M16 2v3M3 9h18M5 4h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2Z',
  phone: 'M5 4h3l2 5-2.5 1.5a11 11 0 0 0 5 5L14 14l5 2v3a1 1 0 0 1-1 1A15 15 0 0 1 4 5a1 1 0 0 1 1-1Z',
  bolt: 'M13 3 4 14h6l-1 7 9-11h-6l1-7Z',
  download: 'M12 4v10m0 0 4-4m-4 4-4-4M5 19h14',
  paperclip: 'M20 11.5 12 19a5 5 0 0 1-7-7l8-8a3.5 3.5 0 0 1 5 5l-8 8a2 2 0 0 1-3-3l7-7',
  more: 'M5 12h.01M12 12h.01M19 12h.01',
  shield: 'M12 3l7 3v5c0 4.5-3 8.5-7 10-4-1.5-7-5.5-7-10V6l7-3Z',
  star: 'M12 3l2.7 5.6 6.3.9-4.5 4.4 1 6.1-5.5-2.9-5.5 2.9 1-6.1L3 9.5l6.3-.9L12 3Z',
  link: 'M10 14a4 4 0 0 0 6 .4l3-3a4 4 0 0 0-5.6-5.6L12 7.2M14 10a4 4 0 0 0-6-.4l-3 3a4 4 0 0 0 5.6 5.6l1.4-1.4',
  listOl: 'M10 6h10M10 12h10M10 18h10M4 5h1v4M4 9h2M4 13.5c0-.8 2-1 2 0 0 .7-2 1.6-2 2.5h2',
  listUl: 'M9 6h11M9 12h11M9 18h11M4.5 6h.01M4.5 12h.01M4.5 18h.01',
  quote: 'M5 7h5v5H6.5A2.5 2.5 0 0 0 4 14.5V17M14 7h5v5h-3.5a2.5 2.5 0 0 0-2.5 2.5V17',
  code: 'M8 7 4 12l4 5M16 7l4 5-4 5',
  codeblock: 'M4 5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1ZM10 9l-2.5 3L10 15M14 9l2.5 3L14 15',
  video: 'M4 7a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1ZM15 10l5-3v10l-5-3',
  mic: 'M12 3a3 3 0 0 1 3 3v6a3 3 0 0 1-6 0V6a3 3 0 0 1 3-3ZM6 11a6 6 0 0 0 12 0M12 17v4M9 21h6',
  slashSquare: 'M5 4h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1ZM14 8l-4 8',
  plane: 'M4 11.5 20 4l-4.5 16-4-6.5L4 11.5ZM11.5 13.5 20 4',
  at: 'M16 12a4 4 0 1 0-1.2 2.9c.6.7 1.7 1 2.6.5 1.3-.7 1.6-2 1.6-3.4a7 7 0 1 0-2.8 5.6',
  browse: 'M4 6h10M4 10h10M4 14h6M14.5 13.5a3.5 3.5 0 1 0 5 5l2 2M14.5 13.5a3.5 3.5 0 0 1 5 5',
  markread: 'M5 5h10a1 1 0 0 1 1 1v3M5 5v14h14v-8M5 5l7 7 3-3M17 3l2 2 4-4',
  apps: 'M5 5h.01M12 5h.01M19 5h.01M5 12h.01M12 12h.01M19 12h.01M5 19h.01M12 19h.01M19 19h.01',
  screen: 'M4 5h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1ZM12 8v5M9.5 10.5 12 8l2.5 2.5M9 21h6',
  micoff: 'M9 9v3a3 3 0 0 0 4.5 2.6M15 11.5V6a3 3 0 0 0-5.7-1.3M6 11a6 6 0 0 0 9 5.2M12 19v2M4 3l16 16',
  close: 'M6 6l12 12M18 6 6 18',
  forward: 'M13 7l5 5-5 5M18 12H7a3 3 0 0 0-3 3v2',
  pin: 'M9 3h6l-1 6 3 3v2h-4v5l-1 2-1-2v-5H6v-2l3-3-1-6Z',
  note: 'M6 3h8l5 5v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1ZM14 3v5h5M9 13h6M9 16.5h4',
  tasks: 'M11 6h9M11 12h9M11 18h9M4 6l1.5 1.5L8.5 4.5M4 12l1.5 1.5L8.5 10.5M4 18l1.5 1.5L8.5 16.5',
  trash: 'M5 7h14M10 7V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2M6 7l1 12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-12M10 11v6M14 11v6',
  eye: 'M2 12s3.5-6.5 10-6.5S22 12 22 12s-3.5 6.5-10 6.5S2 12 2 12zM12 12m-2.6 0a2.6 2.6 0 1 0 5.2 0 2.6 2.6 0 1 0-5.2 0',
  userplus: 'M9 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM3 20a6 6 0 0 1 12 0M18 8v6M21 11h-6',
  people: 'M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM3 20a6 6 0 0 1 12 0M16 5.5a3 3 0 0 1 0 5.4M21 20a6 6 0 0 0-4.5-5.8',
  grid: 'M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h6v6h-6z',
};

export function Icon({ name, size = 18 }: { name: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.9}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={P[name] || P.home} />
    </svg>
  );
}

// ── Real 3D-rendered icon objects (Fluent Emoji 3D, MIT). Vite rewrites the
//    URLs so they respect the app's base path. Keyed by bare filename. ──
const ICON3D_URLS = import.meta.glob('./icons3d/*.png', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;
const icon3d: Record<string, string> = {};
for (const path in ICON3D_URLS) {
  const key = path.split('/').pop()!.replace(/\.png$/, '');
  icon3d[key] = ICON3D_URLS[path];
}

export function has3d(name: string): boolean {
  return name in icon3d;
}

export function Icon3D({ name, size = 26 }: { name: string; size?: number }) {
  const url = icon3d[name];
  if (!url) return <Icon name={name} size={size} />;
  return (
    <img
      className="fx-icon3d"
      src={url}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      draggable={false}
    />
  );
}

/** File-type icon from the file-icon-vectors pack (per-extension SVG, blank fallback). */
export function FileBadge({ name, size = 30 }: { name?: string | null; mime?: string; size?: number }) {
  const ext = ((name || '').split('.').pop() || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  return (
    <img
      className="fx-file-badge"
      style={{ width: size, height: Math.round(size * 4 / 3) }}
      src={`/public/fileicons/vivid/${ext || 'blank'}.svg`}
      alt=""
      aria-hidden
      onError={(e) => { (e.target as HTMLImageElement).src = '/public/fileicons/vivid/blank.svg'; }}
    />
  );
}
